import { Component } from '@angular/core';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar #nbsidebar class="menu-sidebar" tag="menu-sidebar" responsive start>
        <ng-content select="nb-menu"></ng-content>
        <nb-sidebar-footer *ngIf="!(nbsidebar.compacted || nbsidebar.collapsed)">
          <ng-content select="nb-toggle"></ng-content>
        </nb-sidebar-footer>
      </nb-sidebar>

      <nb-layout-column style="padding: 0.85rem 0.8rem 0.75rem !important;">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {}
